import { initializeSentry } from "@blis/telemetry/client";

declare global {
  interface Window {
    __BLIS_CONFIG__?: {
      sentryDsn?: string;
      environment?: string;
      version?: string;
      tenant?: string;
    };
  }
}

const { sentryDsn, environment, version, tenant } =
  window.__BLIS_CONFIG__ ?? {};

initializeSentry({ dsn: sentryDsn, environment, version, tenant });
